import connectSortBy from "instantsearch.js/es/connectors/sort-by/connectSortBy.js";
import { useConnector } from "../hooks/useConnector.js";
export function useSortBy(props, additionalWidgetProperties) {
  return useConnector(connectSortBy, props, additionalWidgetProperties);
}